// Loader.jsx
import { Spinner } from "react-bootstrap";

function Loader({ text = "Loading..." }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Spinner animation="border" size="sm" />
      <span>{text}</span>
    </div>
  );
}

export default Loader;
